module.exports = __webpack_public_path__ + "static/media/icon-pgy.a97b0c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/icon-pgy.png
// module id = 2135
// module chunks = 6